<template>

    <div class="i-card__panel i-card__panel__bottom ycmd-blue-vertical-gradient pa-2 pt-0">

        <v-overlay :value="Boolean(isLoading)" :absolute="true" color="#2389e8" opacity="0.3">
            <div class="d-flex align-center justify-center" >
                <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        </v-overlay>

        <div class="i-card__panel__header">

            <div class="d-flex align-center flex-grow-1">

                <v-tooltip bottom
                           nudge-bottom="10"
                           nudge-right="50"
                           :disabled="$vuetify.breakpoint.xsOnly"
                           color="ycmd-black"
                           content-class="fade-0 pa-4 pt-2 pb-2">
                    <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on" @click="setPanel('bottom', false)" class="ml-2 mr-2">
                            <v-icon :size="20">close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cancel</span>
                </v-tooltip>

                <div class="white--text fs-14 ml-3">
                    New Message
                </div>

                <v-spacer />

                <v-tooltip bottom
                           nudge-bottom="0"
                           nudge-right="32"
                           color="ycmd-black"
                           :disabled="$vuetify.breakpoint.xsOnly"
                           content-class="fade-0 pa-4 pt-2 pb-2">
                    <template v-slot:activator="{ on }">
                        <v-btn icon light small
                               @click="sendMessage"
                               v-on="on"
                               class="ycmd-green ml-4 mr-0">
                            <v-icon color="white" :size="18">chevron_right</v-icon>
                        </v-btn>
                    </template>
                    <span>Send Message</span>
                </v-tooltip>

            </div>
            <div class="d-flex align-center justify-end ml-2">

            </div>
        </div>

        <div class="i-card__panel__content white br-2 pa-2">

            <div class="i-card__scrollable">

                <v-container fluid class="ycmd-light-gray pa-0 b b-1 br-2">

                    <v-form ref="messageSendForm" v-model="validSendForm"
                          class="d-flex flex-column full-width full-height pl-4 pr-4 pt-2">

                        <v-row
                        >
                            <v-col cols="12">
                                <div class="error white--text" v-if="field_error">{{field_error}}</div>

                            </v-col>
                        </v-row>


                        <v-row
                            v-if="nurseView"
                        >
                            <v-col cols="12" sm="6" md="6">
                                <div class="label-title pb-2">Location</div>

                                <ycmd-facility-search
                                    v-model="nurseFacility"
                                    :rules="[rules.required]"
                                    :initialValue="defaultLocation"
                                    />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <div class="label-title pb-2">{{nurseFacilityCallbackLabel}}</div>
                                <v-text-field light solo dense flat outlined
                                    placeholder="Callback number"
                                    v-model="nurseFormattedPhoneNumber"
                                    />
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <div class="label-title pb-2">Physician Name</div>
                                <ycmd-provider-search
                                    :rules="[rules.required]"
                                    :providerSearchSelected.sync="sendMessageData.to_user_id"
                                    :facilityId="providerSearchFacility"
                                    :initialValue="initialProvider"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <div class="label-title pb-2">Person You Are Paging For</div>
                                <v-text-field light solo dense flat outlined
                                    placeholder="Leave blank if paging for yourself"
                                    v-model="sendMessageData.guest_name" />
                            </v-col>
                            <v-col cols="6" sm="6" md="4" lg="4">
                                <div class="label-title pb-2">Patient Type</div>
                                <v-select light dense flat outlined
                                    v-model="sendMessageData.patient_status"
                                    :items="patientTypeList"
                                    item-text="name"
                                    item-value="value"
                                    background-color="white"
                                    return-object />
                            </v-col>
                            <template v-if="sendMessageData.patient_status && sendMessageData.patient_status.name === 'Established'" class="">
                                <v-col cols="6" sm="6" md="4">
                                    <div class="label-title pb-2">Patient</div>
                                    <ycmd-patient-search :rules="[rules.required]" :userId="sendMessageData.to_user_id" :patientSearchSelected.sync="sendMessageData.patient_id"/>
                                </v-col>
                            </template>
                            <template v-else-if="sendMessageData.patient_status && sendMessageData.patient_status.name === 'New'">
                                <v-col cols="6" sm="6" md="4" lg="3">
                                    <div class="label-title pb-2">First Name</div>
                                    <v-text-field light solo dense flat outlined
                                                  :rules="[rules.required]"
                                                  v-model="sendMessageData.patient_fname" />
                                </v-col>
                                <v-col cols="2" sm="2" md="1" lg="1">
                                    <div class="label-title pb-2">Initial</div>
                                    <v-text-field light solo dense flat outlined style="min-width: 34px;"
                                                  v-model="sendMessageData.patient_initial"
                                                  :maxlength="1"/>
                                </v-col>
                                <v-col cols="10" sm="6" md="4" lg="3">
                                    <div class="label-title pb-2">Last Name</div>
                                    <v-text-field light solo dense flat outlined
                                                  :rules="[rules.required]"
                                                  v-model="sendMessageData.patient_lname" />
                                </v-col>
                                <v-col cols="12" sm="12" md="12" v-if="!nurseView">
                                    <div class="label-title">Established</div>
                                    <div class="d-flex">
                                        <v-checkbox
                                          v-model="sendMessageData.establishedPatient"
                                          :label="`Established Patient (Patient not in system)`"
                                          class="flex-grow-0"
                                        ></v-checkbox>
                                        <v-spacer />
                                    </div>
                                </v-col>
                            </template>
                            <v-col cols="6" sm="6" md="4">
                                <!-- (mm/dd/yyyy)  -->
                                <div class="label-title pb-2">Patient DOB</div>
                                <v-text-field light solo dense flat outlined
                                            v-mask="toggleMaskDOB"
                                            placeholder="mm/dd/yyyy"
                                            :rules="[rules.required, rules.dob]"
                                            v-model="sendMessageData.patient_dob" />
                            </v-col>
                            <v-col cols="6" sm="6" md="4" v-if="!nurseView">
                                <div class="label-title pb-2">Patient Location</div>
                                <ycmd-facility-search
                                    :key="`facility-search-${reload}`"
                                    :disabled="(sendMessageData.to_user_id && sendMessageData.to_user_id.id ? false : true)"
                                    :groupIDS="(this.sendMessageData.to_user_id && this.sendMessageData.to_user_id.group_id ? [this.sendMessageData.to_user_id.group_id] : null)"
                                    :rules="[rules.required]"
                                    :facilitySearchSelected.sync="sendMessageData.facility_id"/>
                            </v-col>
                            <v-col cols="6" sm="6" md="4" v-if="!nurseView">
                                <div class="label-title pb-2">Callback Number</div>
                                <v-text-field light solo dense flat outlined
                                              v-mask="masks.phone"
                                              :rules="[rules.required, rules.phone]"
                                              v-model="sendMessageData.callback" />
                            </v-col>
                            <v-col cols="6" sm="6" md="4" v-if="!nurseView">
                                <div class="label-title pb-2">Extension</div>
                                <v-text-field light solo dense flat outlined
                                              v-model="sendMessageData.extension" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <!-- Custom Fields -->
                            <v-col
                                v-for="(field, i) in customFields"
                                :key="`custom_field_${i}`"
                                cols="12" sm="12" md="6" lg="4">

                                <div class="d-flex flex-row align-center">
                                    <div class="label-title pb-2">{{field.label || 'Custom Field'}}</div>
                                    <v-spacer />
                                    <div class="label-title pb-2" style="font-size: 10px;">{{field.description || ''}}</div>
                                </div>
                                <v-select v-if="field.field_type === 'single_select'"
                                    light dense flat outlined
                                    v-model="field.value"
                                    placeholder="Select an option"
                                    :items="field.options"
                                    :rules="[(field.required ? rules.required : true)]"
                                    item-text="value"
                                    background-color="white"
                                    return-object />
                                <v-text-field v-else-if="field.field_type === 'input'"
                                    light dense flat outlined
                                    v-model="field.value"
                                    :rules="[(field.required ? rules.required : true)]"
                                    placeholder="Type answer here"
                                    background-color="white"
                                    return-object />
                                <!-- <div v-if="field.description" class="label-title pb-2">{{field.description || 'Custom Description'}}</div> -->

                            </v-col>
                        </v-row>

                        <v-row class="mt-4">
                            <v-col cols="12" sm="12" md="12">
                                <div class="label-title pb-2">Message</div>
                                <v-textarea
                                        light dense flat outlined
                                        :rules="[rules.required]"
                                        class="small-input"
                                        auto-grow
                                        v-model="sendMessageDataNoWatch.contents"
                                        rows="3"
                                        background-color="white" />
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="!nurseView">
                                <div class="label-title">Bypass On-Call Coverage</div>
                                <div class="d-flex">
                                    <v-checkbox
                                      v-model="sendMessageData.bypass_coverage"
                                      :tabindex="0"
                                      :label="`This will by pass on-call coverage, but procedures will still be followed`"
                                    ></v-checkbox>
                                    <v-spacer />
                                </div>
                            </v-col>
                        </v-row>

                    </v-form>

                </v-container>

            </div>

        </div>

    </div>

</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import { format, parseISO, formatISO } from 'date-fns';

    //import {patientType} from '@/data/communications/constants';
    import { formatPhoneNumber } from '@/methods/globalMethods';

    import YCMDFacilitySearch from '@/components/searches/ycmd-facility';
    import YCMDProviderSearch from '@/components/searches/ycmd-provider';
    import YCMDPatientSearch from '@/components/searches/ycmd-patient';

    import SEND_MESSAGE from '@/graphql/mutations/phoenix/ycmdMessageSend';
    import GET_MESSAGE_FIELDS from '@/graphql/queries/phoenix/ycmdMessageFields';
    import {inactivityTimer} from '@/graphql/handler/inactivityTimer'

    export default {
        name: 'messagesNewMessage',
        components: {
            'ycmd-facility-search': YCMDFacilitySearch,
            'ycmd-provider-search': YCMDProviderSearch,
            'ycmd-patient-search': YCMDPatientSearch
        },
        props: {
            submitAdvancedSearch: Function,
            setPanel: Function,
            newMessageProvider: Object
        },
        apollo: {
            $client: 'phoenixClient'
        },
        data() {
            return {
                format,
                parseISO,
                //patientType,
                card: {
                    index: 0,
                    panels: { left: false, right: false, top: false, bottom: false }
                },
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    phone: number => {
                        // const pattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/gm;
                        const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                        return pattern.test(number) || 'Invalid number. Please use (###) ###-####';
                    },
                    dob: date => {
                        return !!this.formatDOB(date) || 'Invalid date. Please use mm/dd/yyy.';
                        // const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
                        // return pattern.test(date) || 'Invalid date. Please use mm/dd/yyy.';
                    }
                },
                masks: {
                    phone: '(###) ###-####',
                    dob: '##/##/####'
                },
                isLoading: false,
                validSendForm: false,
                physicianName: '',
                pagingFor: '',

                customFields: {},

                sendMessageData: {
                    to_user_id: null,
                    guest_name: null,
                    patient_id: null,
                    patient_fname: null,
                    patient_lname: null,
                    patient_initial: null,
                    patient_dob: null,
                    facility_id: null,
                    callback: null,
                    extension: null,
                    bypass_coverage: null,
                    message_answers: null,
                    patient_status: null,

                    // unsure about these
                    guest_name: null,
                    unit_shortcode: null,

                    // still needs endpoint
                    establishedPatient: false,
                },
                sendMessageDataNoWatch: {
                    contents: null
                },
                nurseFacility: {},
                nurseFacility_number: null,
                reload: 0,
                field_error: null
            }
        },
        activated() {

        },
        created() {

        },
        mounted() {
            this.clearForm();
        },
        computed: {
            initialProvider () {
                return this.newMessageProvider ? this.newMessageProvider : null
            },
            patientTypeList () {
                console.log('selectedFacility', this.selectedFacility)

                let list = [
                    {
                        name: 'Established',
                        value: 'established'
                    }
                ]
                
                if (!this.nurseView || !this.selectedFacility || this.selectedFacility.new_patients) {
                    list.push(
                        {
                            name: 'New',
                            value: 'new'
                        }
                    )
                }                
                
                return list
            },
            toggleMaskDOB: function() {
                return (this.sendMessageData.patient_id && this.sendMessageData.patient_id.dob) ? null : this.masks.dob
            },
            legacyRoleMap () {
                let map = {}
                let roles = this.getLegacyRoles
                console.log('roles', roles)
                if (roles && roles.length) {
                    roles.map(r => {
                        map[r] = true
                    })
                }
                return map
            },
            nurseView () {
                if (this.legacyRoleMap['provider']) {
                    return false
                }
                if (this.legacyRoleMap['member']) {
                    return false
                }
                if (this.legacyRoleMap['nurse']) {
                    return true
                }

                return false

            },
            nurseFacilityCallbackLabel () {
                if (this.nurseView) {
                    if (this.nurseFacility && this.nurseFacility.name) {
                        if (!this.nurseFacility_number || formatPhoneNumber(this.stripPhoneNumber(this.nurseFacility_number)) === formatPhoneNumber(this.stripPhoneNumber(this.nurseFacility.number)) ) {
                            return `${this.nurseFacility.name} callback number`
                        } else {
                            return 'Callback number'
                        }
                    } else {
                        return 'Callback number'
                    }
                }
                return ''
            },
            nurseFormattedPhoneNumber: {
                get: function () {
                    if (this.nurseView) {
                        if (this.nurseFacility_number) {
                            return formatPhoneNumber(this.stripPhoneNumber(this.nurseFacility_number));
                        } else if (this.nurseFacility && this.nurseFacility.number) {                            
                            return formatPhoneNumber(this.stripPhoneNumber(this.nurseFacility.number));
                        }
                    }
                    return ''
                },
                set: function(newValue) {
                    this.nurseFacility_number = newValue
                }

            },
            providerSearchFacility () {
                if (this.nurseView) {
                    if (this.nurseFacility && this.nurseFacility.id) {
                        return this.nurseFacility.id
                    }
                }

                return null
            },
            defaultLocation () {
                if (this.newMessageProvider && this.newMessageProvider.location) {
                    return this.newMessageProvider.location
                }

                let preferences = this.getPreferences
                
                let location = preferences.find(p => {
                    return p.name == 'location'
                })

                return location ? location.value : null
            },
            selectedFacility () {
                return this.nurseView ? this.nurseFacility : this.sendMessageData.facility_id
            },
            defaultPatientType () {
                let index = 0

                if (this.selectedFacility && this.selectedFacility.default_patient_status && this.patientTypeList && this.patientTypeList.length) {
                    index = this.patientTypeList.findIndex(t => {
                        return t.value === this.selectedFacility.default_patient_status
                    })
                    if (index < 0) {
                        index = 0
                    } 
                }   

                if (this.patientTypeList && this.patientTypeList.length) {
                    return this.patientTypeList[index];
                }

                return null

            },
            ...mapGetters('profile', ['getLegacyRoles', 'getPreferences'])
        },
        watch: {
            sendMessageData: {
                handler: _.debounce(function (val, oldVal) {
                    // console.log('new val: ', val);
                    // check required fields
                    if (!val.to_user_id) {
                        // if required field is missing reset custom fields
                        if (!_.isEmpty(this.customField)) {
                            this.customFields = {};
                        }
                    } else {
                        this.getMessageFields();
                    }
                    inactivityTimer()
                }, 200),
                deep: true,
                immediate: false
            },
            customFields: {
                handler: _.debounce(function (val, oldVal) {
                    // console.log('CUSTOM FIELDS CHANGED: ', oldVal, val);
                    // check required fields
                    if (this.sendMessageData.to_user_id) {
                        this.getMessageFields();
                    }
                }, 200),
                deep: true,
                immediate: false
            },
            selectedFacility: {
                handler: function (val, oldVal) {
                    // re-validate form
                    /*
                    take out because resets the form
                    if (val && val.default_patient_status) {
                        this.$nextTick(() => {
                            this.sendMessageData.patient_status = this.defaultPatientType
                        })                        
                    }
                    */
                },
                deep: false,
                immediate: false
            },
            'sendMessageData.patient_status': {
                handler: function (val, oldVal) {
                    // re-validate form
                    this.$nextTick(() => {
                        this.$refs.messageSendForm.resetValidation()
                    })
                    // reset to default values (switch)
                    this.sendMessageData.patient_fname = null;
                    this.sendMessageData.patient_lname = null;
                    this.sendMessageData.patient_initial = null;
                    this.sendMessageData.establishedPatient = false;
                    this.sendMessageData.patient_id = null;
                    this.sendMessageData.patient_dob = null;
                },
                deep: false,
                immediate: false
            },
            'sendMessageData.patient_id': {
                handler: function (val, oldVal) {
                    // check to fill DOB (group does this)
                    if (val && val.dob) {
                        this.sendMessageData.patient_dob = val.dob;
                    } else {
                        // needs nextTick reset for masks
                        this.$nextTick(() => {
                            this.sendMessageData.patient_dob = null;
                        })
                    }
                },
                deep: true,
                immediate: false
            },
            'sendMessageData.facility_id': {
                handler: function (val, oldVal) {
                    // check to fill callback number (group does this)
                    if (val && val.number) {
                        this.sendMessageData.callback = formatPhoneNumber(this.stripPhoneNumber(val.number));
                    } else {
                        this.$nextTick(() => {
                            this.sendMessageData.callback = null;
                        })
                    }
                },
                deep: true,
                immediate: false
            },
            'sendMessageData.to_user_id': {
                handler: function (val, oldVal) {
                    // console.log('to user id: ', val);
                    if (this.sendMessageData.facility_id) {
                        this.sendMessageData.facility_id = null;
                    }
                    // check if we just cleared to user form
                    if (!val) {
                        this.customFields = {};
                    }
                },
                deep: true,
                immediate: false
            }
        },
        methods: {
            route(name, transition) {

              this.$router.push({
                name: name, params: {
                  transition: transition
                }
              }).catch(err => { console.log('router error: ', err) });
            },
            slide(direction) {
                this.card.panels[direction] = !this.card.panels[direction];
            },
            stripPhoneNumber(number) {
                if (typeof number === 'string') {
                    return number.replace(/\D/g,'');
                }
                return number;
            },
            formatDOB(date) {
                try {
                    return new Date(date).toISOString();
                } catch {
                    return null
                }
            },
            clearForm() {
                //this.$refs.messageSendForm.reset();             
                this.sendMessageData = {
                    to_user_id: null,
                    guest_name: null,
                    patient_id: null,
                    patient_fname: null,
                    patient_lname: null,
                    patient_initial: null,
                    patient_dob: null,
                    facility_id: null,
                    callback: null,
                    extension: null,
                    bypass_coverage: null,
                    message_answers: null,
                    patient_status: null,

                    // unsure about these
                    guest_name: null,
                    unit_shortcode: null,

                    // still needs endpoint
                    establishedPatient: false,
                }

                this.facilitySearchSelected = null
                this.reload++
                this.customFields = {}
                this.sendMessageDataNoWatch = {
                    contents: null
                }

                // reset init values
                this.$nextTick(() => {
                    this.sendMessageData.patient_status = this.defaultPatientType;
                    // reset masks
                    this.sendMessageData.callback = null;
                })
                this.field_error = null
            },
            getMessageFields : _.debounce(async function getMessageFields() {

                // console.log('Custom message fields send: ', {
                //     to_user_id: this.sendMessageData.to_user_id ? this.sendMessageData.to_user_id.id : null,
                //     guest_name: this.sendMessageData.guest_name ? this.sendMessageData.guest_name : null,
                //     patient_status: this.sendMessageData.patient_status ? this.sendMessageData.patient_status.value : null,
                //     patient_id: this.sendMessageData.patient_id ? this.sendMessageData.patient_id.id : null,
                //     patient_fname: this.sendMessageData.patient_fname ? this.sendMessageData.patient_fname : null,
                //     patient_lname: this.sendMessageData.patient_lname ? this.sendMessageData.patient_lname : null,
                //     patient_dob: (this.sendMessageData.patient_dob && this.formatDOB(this.sendMessageData.patient_dob)) ? this.formatDOB(this.sendMessageData.patient_dob) : null,
                //     facility_id: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.id : null,
                //     unit_shortcode: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.shortcode : null,
                //     callback: this.sendMessageData.callback ? this.sendMessageData.callback : null,
                //     extension: this.sendMessageData.extension ? this.sendMessageData.extension : null,
                //     bypass_coverage: this.sendMessageData.bypass_coverage ? this.sendMessageData.bypass_coverage : null,
                //     direct_admit: this.sendMessageData.establishedPatient ? this.sendMessageData.establishedPatient : null,
                //     message_answers: this.customFields ? this.parseCustomFields(this.customFields) : null
                // });

                try {
                    const response = await this.$apollo.query({
                        query: GET_MESSAGE_FIELDS,
                        variables: {
                            to_user_id: this.sendMessageData.to_user_id ? this.sendMessageData.to_user_id.id : null,
                            guest_name: this.sendMessageData.guest_name ? this.sendMessageData.guest_name : null,
                            patient_status: this.sendMessageData.patient_status ? this.sendMessageData.patient_status.value : null,
                            patient_id: this.sendMessageData.patient_id ? this.sendMessageData.patient_id.id : null,
                            patient_fname: this.sendMessageData.patient_fname ? this.sendMessageData.patient_fname : null,
                            patient_lname: this.sendMessageData.patient_lname ? this.sendMessageData.patient_lname : null,
                            patient_dob: (this.sendMessageData.patient_dob && this.formatDOB(this.sendMessageData.patient_dob)) ? this.formatDOB(this.sendMessageData.patient_dob) : null,
                            facility_id: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.id : null,
                            unit_shortcode: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.shortcode : null,
                            callback: this.sendMessageData.callback ? this.sendMessageData.callback : null,
                            extension: this.sendMessageData.extension ? this.sendMessageData.extension : null,
                            bypass_coverage: this.sendMessageData.bypass_coverage ? this.sendMessageData.bypass_coverage : null,
                            direct_admit: this.sendMessageData.establishedPatient ? this.sendMessageData.establishedPatient : null,
                            message_answers: this.customFields ? this.parseCustomFields(this.customFields) : null
                        },
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'all'
                    });

                    // console.log('response: ', response);

                    const { ycmdMessageFields } = response.data

                    if (ycmdMessageFields) {
                        if (ycmdMessageFields.fields.length) {
                            // new custom fields came back
                            const newCustomFields = {};
                            for (let field in ycmdMessageFields.fields) {
                                const currentField = ycmdMessageFields.fields[field];
                                if (this.customFields[currentField.id]) {
                                    newCustomFields[currentField.id] = this.customFields[currentField.id];
                                } else {
                                    newCustomFields[currentField.id] = currentField;
                                }
                            }
                            if (!_.isEqual(newCustomFields, this.customFields)) {
                                this.customFields = newCustomFields;
                            }
                        } else {
                            // ycmdMessageFields came back but no custom fields, reset custom fields
                            if (!_.isEmpty(this.customField)) {
                                this.customFields = {};
                            }
                        }
                        this.field_error = ycmdMessageFields.device && ycmdMessageFields.device.message ? ycmdMessageFields.device.message : null
                    } else {
                        // data did not come back
                        console.log('ycmdMessageSend did not come back: ', response);
                    }
                } catch (e) {
                    // this.$toasted.error(`Caught an error trying to get custom fields`);
                    console.log('WARNING: Caught error - ', e);
                    // defaultErrorHandler(e);
                }

            }, 200),
            async sendMessage() {
                // console.log(this.sendMessageData.to_user_id);
                // console.log('SENDING: ', {
                //     to_user_id: this.sendMessageData.to_user_id ? this.sendMessageData.to_user_id.id : null,
                //     guest_name: this.sendMessageData.guest_name ? this.sendMessageData.guest_name : null,
                //     patient_status: this.sendMessageData.patient_status ? this.sendMessageData.patient_status.value : null,
                //     patient_id: this.sendMessageData.patient_id ? this.sendMessageData.patient_id.id : null,
                //     patient_fname: this.sendMessageData.patient_fname ? this.sendMessageData.patient_fname : null,
                //     patient_lname: this.sendMessageData.patient_lname ? this.sendMessageData.patient_lname : null,
                //     patient_initial: this.sendMessageData.patient_initial ? this.sendMessageData.patient_initial : null,
                //     patient_dob: (this.sendMessageData.patient_dob && this.formatDOB(this.sendMessageData.patient_dob)) ? this.formatDOB(this.sendMessageData.patient_dob) : null,
                //     facility_id: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.id : null,
                //     unit_shortcode: this.sendMessageData.facility_id ? this.sendMessageData.facility_id.shortcode : null,
                //     callback: this.sendMessageData.callback ? this.sendMessageData.callback : null,
                //     extension: this.sendMessageData.extension ? this.sendMessageData.extension : null,
                //     contents: this.sendMessageData.contents ? this.sendMessageData.contents : null,
                //     bypass_coverage: this.sendMessageData.bypass_coverage ? this.sendMessageData.bypass_coverage : null,
                //     direct_admit: this.sendMessageData.establishedPatient ? this.sendMessageData.establishedPatient : null,
                //     message_answers: this.customFields ? this.parseCustomFields(this.customFields) : null,
                // });

                // validation
                this.$refs.messageSendForm.validate();
                if (!this.validSendForm) return;

                if (this.field_error) {
                    return
                }

                // show loader
                this.isLoading = true;

                try {
                    let facility_id = this.sendMessageData.facility_id
                    let callback = this.sendMessageData.callback
                    let extension = this.sendMessageData.extension
                    if (this.nurseView) {
                        facility_id = this.nurseFacility
                        callback = this.nurseFormattedPhoneNumber
                    }
                    const response = await this.$apollo.mutate({
                        mutation: SEND_MESSAGE,
                        variables: {
                            to_user_id: this.sendMessageData.to_user_id ? this.sendMessageData.to_user_id.id : null,
                            guest_name: this.sendMessageData.guest_name ? this.sendMessageData.guest_name : null,
                            patient_status: this.sendMessageData.patient_status ? this.sendMessageData.patient_status.value : null,
                            patient_id: this.sendMessageData.patient_id ? this.sendMessageData.patient_id.id : null,
                            patient_fname: this.sendMessageData.patient_fname ? this.sendMessageData.patient_fname : null,
                            patient_lname: this.sendMessageData.patient_lname ? this.sendMessageData.patient_lname : null,
                            patient_initial: this.sendMessageData.patient_initial ? this.sendMessageData.patient_initial : null,
                            patient_dob: (this.sendMessageData.patient_dob && this.formatDOB(this.sendMessageData.patient_dob)) ? this.formatDOB(this.sendMessageData.patient_dob) : null,
                            facility_id: facility_id ? facility_id.id : null,
                            unit_shortcode: facility_id ? facility_id.shortcode : null,
                            callback: callback ? callback : null,
                            extension: extension,
                            contents: this.sendMessageDataNoWatch.contents ? this.sendMessageDataNoWatch.contents : null,
                            bypass_coverage: this.sendMessageData.bypass_coverage ? this.sendMessageData.bypass_coverage : null,
                            direct_admit: this.sendMessageData.establishedPatient ? this.sendMessageData.establishedPatient : null,
                            message_answers: this.customFields ? this.parseCustomFields(this.customFields) : null,
                        },
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'all'
                    });
                    this.isLoading = false;
                    // check errors
                    // console.log('response: ', response);

                    const { ycmdMessageSend } = response.data

                    let value
                    
                    if (facility_id) {
                        value = `${facility_id.id}|${facility_id.shortcode}`
                    }

                    if (ycmdMessageSend) {
                        this.$store.commit('profile/setPreference',
                            {
                                name: 'location',
                                value: value
                            }
                        )
                        this.clearForm();
                        this.$toasted.success(`${ycmdMessageSend.message ? ycmdMessageSend.message : 'Successfully sent message'}`);
                    } else {
                        // data did not come back
                        let errorMessage = `There was an error sending the message`
                        if (response.errors && response.errors.length) {
                            errorMessage = response.errors[0].message
                            if (errorMessage.startsWith('[{"field')) {
                                let eobj = JSON.stringify(response.errors[0].message)
                                errorMessage = eobj.message
                            }
                        }
                        this.$toasted.error(errorMessage);
                        console.log('ycmdMessageSend did not come back: ', response);
                    }
                } catch (e) {
                    this.isLoading = false;
                    this.$toasted.error(`Caught an error sending message`);
                    console.log('WARNING: Caught error - ', e);
                    // defaultErrorHandler(e);
                }

            },
            parseCustomFields(data) {
                let filteredFields = [];
                for (let item in data) {
                    const currentItem = data[item];
                    if (currentItem.id && currentItem.value) {
                        filteredFields.push({
                            id: currentItem.id,
                            value: currentItem.value.id || currentItem.value
                        })
                    }
                }
                return filteredFields.length ? filteredFields : null
            }
        }
    }

</script>

<style scoped>

    .item-box {
        background-color: #fff;
        border-bottom: #177ad5 solid 1px;
    }

    .item-box.odd {
        background-color: #ECEFF1;
    }

    .item-box:hover {
        background-color: rgba(255, 255, 255, 0.8)
    }

</style>
